module.exports = __webpack_public_path__ + "img/img8-logo.cf4113e9.png";